import { useEffect, useRef, useState } from "react";

/** Count-up/down animation for dashboard figures. */
export default function AnimatedCounter({
  value,
  format = (v) => String(v),
  duration = 600,
  flash = null,
  className = "",
}) {
  const [display, setDisplay] = useState(value);
  const [flashing, setFlashing] = useState(false);
  const prev = useRef(value);
  const raf = useRef(null);

  useEffect(() => {
    const from = prev.current;
    const to = value;
    if (from === to) return;

    const start = performance.now();
    const diff = to - from;

    const tick = (now) => {
      const t = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - t, 3);
      setDisplay(from + diff * eased);
      if (t < 1) {
        raf.current = requestAnimationFrame(tick);
      } else {
        setDisplay(to);
        prev.current = to;
      }
    };

    if (flash) {
      setFlashing(true);
      const t = setTimeout(() => setFlashing(false), 600);
      raf.current = requestAnimationFrame(tick);
      return () => {
        cancelAnimationFrame(raf.current);
        clearTimeout(t);
      };
    }

    raf.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf.current);
  }, [value, duration, flash]);

  const flashClass =
    flashing && flash === "up"
      ? "kipa-counter-flash-up"
      : flashing && flash === "down"
        ? "kipa-counter-flash-down"
        : "";

  return (
    <span className={`kipa-counter ${flashClass} ${className}`}>
      {format(display)}
    </span>
  );
}
